export const createApplePaySession = (
  version: number,
  request: ApplePayJS.ApplePayPaymentRequest,
  onCancel?: () => void
) => {
  const session = new ApplePaySession(version, request);

  if (onCancel) {
    session.oncancel = onCancel;
  }

  return session;
};
